// The hall-browser flow. Not a row in the public table.
//
// PUBLIC `start → form` STAYS IMPOSSIBLE. That absence is the mailbox ruling.
// This file is a different product: presence is the proof, there is no emailed
// code, and the channel is onsite_web. Adding these transitions to flow.ts
// would be the photographed-QR shortcut wearing an onsite costume.

export type OnsiteStage =
  | { readonly at: "unusable"; readonly problem: string }
  | { readonly at: "start" }
  | { readonly at: "details" }
  | { readonly at: "terms" }
  | { readonly at: "survey" }
  | { readonly at: "writing" }
  | { readonly at: "done" }
  | { readonly at: "refused"; readonly code: string; readonly problem: string };

export const ONSITE_TRANSITIONS: Readonly<Record<OnsiteStage["at"], readonly OnsiteStage["at"][]>> = {
  unusable: [],
  start: ["details", "refused"],
  details: ["terms", "start", "refused"],
  // `start` from the middle of the form is abandonment, not navigation: the
  // idle clock in HomeReset.tsx, or a crew member's three taps in the corner.
  // Going home unmounts the form, which is the only copy of what was typed, so
  // this is also how a walk-away stops being the next person's problem.
  terms: ["survey", "writing", "details", "start", "refused"],
  survey: ["writing", "terms", "start", "refused"],
  // Not `start`. The write is already in flight and its answer is coming.
  writing: ["done", "refused"],
  done: ["start"],
  refused: ["start"],
};

export function onsiteMayFollow(from: OnsiteStage["at"], to: OnsiteStage["at"]): boolean {
  return ONSITE_TRANSITIONS[from].includes(to);
}
